

import React, { Suspense, useContext, useEffect, useState } from 'react';
import { ogToast, ogCloseModal } from '../../../utils/uiHelpers';
import { getAttendance, getAttendanceHistory, getCurrentCheckInStatus, getGeoTagLocation, selfRemarkAttendance } from './Services/AttendanceService';
import { GetMasterTypeData } from '../../../Services/Global-Services/GlobalServices';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ComponentLoader from '../../../Shared/Sidebar/ComponentLoader';
import { TostMsg } from '../../../App';


const My_Attendance = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [attendanceList, setAttendanceList] = useState([]);
  const [view, setView] = useState('calendar');
  const [loading, setLoading] = useState(false);
  const [currentCheck, setCurrentCheck] = useState({});
  const [checkHistory, setCheckHistory] = useState([]);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [attendanceCategoryType, setAttendanceCategoryType] = useState([]);
  const [showCheckStatus, setShowCheckStatus] = useState(false);
  const toster = useContext(TostMsg);
  const DOW_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const [summary, setSummary] = useState({});
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [showLegend, setShowLegend] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const monthLabel = currentMonth.toLocaleDateString("en-IN", {
    month: "long",
    year: "numeric"
  });
  const radius = 36;
  const circumference = 2 * Math.PI * radius;
  const maxHours = 9;
  // ✅ convert string → number safely
  const worked = parseFloat(currentCheck?.TotalWorkingHours) || 0;

  // limit progress to 100%
  const progress = Math.min(worked / maxHours, 1);

  const strokeDashoffset = circumference - (progress * circumference);
  const loadMonthAttendance = (date) => {
    const start = new Date(date.getFullYear(), date.getMonth(), 1);
    const end = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    const fromDate = formatDateOnly(start);
    const toDate = formatDateOnly(end);

    setCurrentMonth(date);

    getAttendanceList(fromDate, toDate);
  };

  const handlePrevMonth = () => {
    const prevMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );

    loadMonthAttendance(prevMonth);
  };

  const handleNextMonth = () => {
    const nextMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );

    loadMonthAttendance(nextMonth);
  };


  const safeDateKey = (dateStr) => {
    if (!dateStr) return null;

    const d = new Date(dateStr);
    if (isNaN(d)) return null;

    return d.toLocaleDateString("en-CA"); // ✅ local YYYY-MM-DD (no UTC bug)
  };


  useEffect(() => {
    getMasterTicketCategory();
    loadMonthAttendance(currentMonth);
    CurrentCheckInStatus();
    AttendanceHistory();
    gettGeoTagLocationList();
  }, [currentMonth]);



  const isSecureContext = () => {
    return (
      window.location.protocol === "https:" ||
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1"
    );
  };

  const checkLocationPermission = async () => {
    try {
      if (!navigator.permissions || !navigator.geolocation) {
        // Browser doesn't support permissions API — let getCurrentPosition handle it
        return "prompt";
      }
      const result = await navigator.permissions.query({ name: "geolocation" });
      return result.state; // "granted" | "denied" | "prompt"
    } catch {
      return "prompt";
    }
  };



  // ✅ Format for UI (Day / Month / Weekday)
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return null;

    const d = new Date(dateStr);
    if (isNaN(d)) return null;

    return {
      day: d.toLocaleDateString('en-IN', { day: '2-digit' }),
      month: d.toLocaleDateString('en-IN', { month: 'short' }).toUpperCase(),
      weekday: d.toLocaleDateString('en-IN', { weekday: 'long' })
    };
  };

  // ✅ Format Time
  const formatTime = (dateStr) => {
    if (!dateStr) return "--";

    const d = new Date(dateStr);

    if (isNaN(d)) return "--";

    return d.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // ✅ Calculate Working Hours

  const calculateHours = (checkIn, checkOut) => {
    if (!checkIn) return 0;
    const start = new Date(checkIn);
    if (isNaN(start) || start.getFullYear() === 1900) return 0;
    const end = checkOut ? new Date(checkOut) : new Date();
    return ((end - start) / (1000 * 60 * 60)).toFixed(1);
  };


  const todayAttendance = React.useMemo(() => {
    if (!attendanceList.length) return null;

    const todayKey = new Date().toLocaleDateString("en-CA"); // YYYY-MM-DD

    return attendanceList.find(
      item => safeDateKey(item.AttendanceDate) === todayKey
    ) || null;

  }, [attendanceList]);

  const dateData = formatDisplayDate(
    todayAttendance?.AttendanceDate || new Date()
  );

  const workedHours = calculateHours(
    todayAttendance?.CheckIn,
    todayAttendance?.CheckOut
  );

  const getStatusLabel = (code) => {
    switch (code) {
      case 'P': return { text: 'Present', class: 'att-P' };
      case 'A': return { text: 'Absent', class: 'att-A' };
      case 'WFH': return { text: 'WFH', class: 'att-WFH' };
      case 'LV': return { text: 'Leave', class: 'att-LV' };
      case 'WO': return { text: 'Week Off', class: 'att-WO' };
      case 'H': return { text: 'Holiday', class: 'att-H' };
      case 'M': return { text: 'Missing', class: 'att-M' };
      default: return { text: '-', class: '' };
    }
  };

  const statusData = todayAttendance
    ? getStatusLabel(todayAttendance.StatusCode)
    : { text: 'No Data', class: '' };

  const STATUS_MAP = {
    P: { cls: 'att-P', label: 'P', desc: 'Present' },
    A: { cls: 'att-A', label: 'A', desc: 'Absent' },
    L: { cls: 'att-L', label: 'L', desc: 'Late' },
    WFH: { cls: 'att-WFH', label: 'WFH', desc: 'Work From Home' },
    LV: { cls: 'att-LV', label: 'LV', desc: 'Leave' },
    WO: { cls: 'att-WO', label: 'WO', desc: 'Week Off' },
    H: { cls: 'att-H', label: 'H', desc: 'Holiday' },
    HD: { cls: 'att-HD', label: '½', desc: 'Half Day' },
  };

  const getStatusMeta = (code) => {
    return STATUS_MAP[code] || { cls: '', label: code || '-', desc: '' };
  };

  function formatDate(dateStr, type = "time") {
    if (!dateStr) return "--";

    const date = new Date(dateStr);

    if (type === "time") {
      return date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }

    if (type === "date") {
      return date.toLocaleDateString();
    }

    return date.toLocaleString();
  }

  async function getMasterTicketCategory() {
    const params = {
      organisationId: userDetails?.OrgId,
      masterType: "AttendanceRegularizationReason",
    };
    // setIsloading(true);
    try {
      const data = await GetMasterTypeData(params);
      setAttendanceCategoryType(data?.Data);
      // setIsloading(false);
    } catch (error) {
      // setIsloading(false);
      // toster.current.error(ERROR_LIST?.MasterDataType);
    }
  }

  async function getAttendanceList(fromDate, toDate) {
    setLoading(true);
    const params = {
      EmployeeId: userDetails?.EmpId ?? 0,
      PageNumber: 1,
      PageSize: 1,
      Search: "",
      FromDate: fromDate,
      ToDate: toDate
    };

    try {
      const response = await getAttendance(params);
      setLoading(false);
      const raw = response?.Data?.AttendanceResults?.[0];

      if (!raw) {
        setAttendanceList([]);
        return;
      }

      // ✅ Summary
      setSummary({
        presentMTD: raw?.presentMTD,
        absentMTD: raw?.AbsentMTD,
        leaveMTD: raw?.LeaveMTD,
        wfhMTD: raw?.WFHMTD,
        attendanceMTD: raw?.AttendanceMTD
      });

      // ✅ Convert D1–D31 → List (FIXED)
      const list = Object.keys(raw)
        .filter(key => key.startsWith("D") && raw[key])
        .map(key => {
          const item = raw[key];
          const dayNumber = parseInt(key.replace("D", ""), 10);

          return {
            ...item,
            day: dayNumber, // ✅ important for D24 → 24
            LocationName:
              item.LocationName ||
              item.CheckOutLocationName
          };
        })
        .filter(item => item.AttendanceDate) // remove invalid
        .sort((a, b) => a.day - b.day); // sort by D number

      setAttendanceList(list);

    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }




  async function CurrentCheckInStatus() {
    setLoading(true);
    const params = {
      Date: new Date().toLocaleString("sv-SE").replace("T", " "),
      EmpId: userDetails?.EmpId ?? 0
    };

    try {
      const response = await getCurrentCheckInStatus(params);
      setLoading(false);
      const data = response?.Data
      setCurrentCheck(data);

    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }


  async function AttendanceHistory(date) {
    setLoading(true);
    const params = {
      Date: date || new Date().toLocaleString("sv-SE").replace("T", " "),
      EmpId: userDetails?.EmpId ?? 0
    };

    try {
      const response = await getAttendanceHistory(params);
      setLoading(false);
      const data = response?.Data

      setCheckHistory(data);

    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  const getCurrentLocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          let msg = "Unable to fetch your location.";
          if (error.code === 1) msg = "Location permission denied. Please allow it in browser settings.";
          if (error.code === 2) msg = "Location unavailable. Check your GPS/network.";
          if (error.code === 3) msg = "Location request timed out. Please try again.";
          reject(msg);
        },
        {
          enableHighAccuracy: true,
          timeout: 20000,
          maximumAge: 0,
        }
      );
    });
  };

  const getDeviceId = () => {
    let deviceId = localStorage.getItem("deviceId");

    if (!deviceId) {
      deviceId = "DEV-" + Math.random().toString(36).substr(2, 9);
      localStorage.setItem("deviceId", deviceId);
    }

    return deviceId;
  };

  async function getPublicIP() {
    try {
      const res = await fetch("https://api.ipify.org?format=json");
      const data = await res.json();
      return data.ip;
    } catch (err) {
      console.error("IP fetch error:", err);
      return "";
    }
  }

  const getDistanceInMeters = (lat1, lon1, lat2, lon2) => {
    const R = 6371000; // Earth radius in meters
    const toRad = (value) => (value * Math.PI) / 180;

    const dLat = toRad(lat2 - lat1);
    const dLon = toRad(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // distance in meters
  };

  const findMatchingLocation = (userLat, userLng, locations) => {
    for (let loc of locations) {
      const distance = getDistanceInMeters(
        userLat,
        userLng,
        loc.Latitude,
        loc.Longitude
      );

      if (distance <= loc.RadiusMetres) {
        return loc; // ✅ inside geofence
      }
    }
    return null; // ❌ outside all locations
  };



  async function addCheckInStatus(type) {
    setLoading(true);

    // ❌ Block on HTTP (not localhost) — GPS not available, don't allow bypass
    if (!isSecureContext()) {
      setLoading(false);
      toster.current.error(
        "Attendance check-in requires a secure (HTTPS) connection. Please use app.orggenie.com."
      );
      return;
    }

    try {
      if (!locations || locations.length === 0) {
        setLoading(false);
        toster.current.error("Location list not loaded yet. Please refresh.");
        return;
      }

      // Step 1: Check permission BEFORE calling getCurrentPosition
      const permission = await checkLocationPermission();

      if (permission === "denied") {
        setLoading(false);
        toster.current.error(
          "Location permission is denied. Please enable it in your browser settings and try again."
        );
        return;
      }

      // Step 2: Get GPS coordinates
      let location;
      try {
        location = await getCurrentLocation();
      } catch (err) {
        setLoading(false);
        toster.current.error(typeof err === "string" ? err : "Unable to get your location.");
        return;
      }

      // Step 3: Geofence check — always required now
      const matchedLocation = findMatchingLocation(
        location.lat,
        location.lng,
        locations
      );

      if (!matchedLocation) {
        setLoading(false);
        toster.current.error(
          "You are outside the allowed location. Check-in is only permitted within your office geofence."
        );
        return;
      }

      // Step 4: Get device info
      const deviceId = getDeviceId();
      const ipAddress = await getPublicIP();

      const params = {
        Id: 0,
        AttendanceDate: new Date().toLocaleString("sv-SE").replace("T", " "),
        IsCheckIn: type,
        Latitude: location.lat,
        Longitude: location.lng,
        LocationId: matchedLocation?.Id || 0,
        IsWithinGeofence: true,
        IsMockGpsDetected: false,
        DeviceUniqueId: deviceId,
        IsRegisteredDevice: false,
        OSVersion: navigator.userAgent ?? "",
        SelfieImagePath: "",
        IsSelfieVerified: false,
        IsOnRegisteredWifi: false,
        WifiSSID: "",
        IPAddress: ipAddress,
      };

      await selfRemarkAttendance(params);

      // Step 5: Refresh data
      await CurrentCheckInStatus();
      loadMonthAttendance(currentMonth);
      AttendanceHistory(new Date().toLocaleString("sv-SE").replace("T", " "));
      setShowCheckStatus(false);

      toster.current.success(type === 1 ? "Checked in successfully!" : "Checked out successfully!");

    } catch (error) {
      console.error(error);
      toster.current.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  const formatDateOnly = (date) => {
    return date.toLocaleDateString("en-CA"); // YYYY-MM-DD
  };

  const handleDatesChange = (arg) => {
    const current = arg.view.currentStart;

    // ✅ First day of month
    const start = new Date(current.getFullYear(), current.getMonth(), 1);

    // ✅ Last day of month
    const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);

    const fromDate = formatDateOnly(start);
    const toDate = formatDateOnly(end);

    // const page = first / rows + 1;

    getAttendanceList(fromDate, toDate);
  };




  const attendanceMap = React.useMemo(() => {
    if (!attendanceList || attendanceList.length === 0) return {};

    const map = {};

    attendanceList.forEach((item) => {
      const key = safeDateKey(item.AttendanceDate);
      if (key) {
        map[key] = item;
      }
    });

    return map;
  }, [attendanceList]);

  const isValidTime = (dateStr) => {
    if (!dateStr) return false;

    const d = new Date(dateStr);

    return !isNaN(d) && d.getFullYear() !== 1900;
  };

  function renderDayCell(dateObj) {
    if (!dateObj || isNaN(dateObj)) return null;
    const dateStr = dateObj.toLocaleDateString("en-CA");
    const apiData = attendanceMap[dateStr];
    const day = dateObj.getDate();
    const todayStr = new Date().toLocaleDateString("en-CA");
    let status = apiData?.StatusCode;
    if (!status) {
      if (dateObj > new Date()) {
        status = "-";
      } else {
        const dayOfWeek = dateObj.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) status = "WO";
      }
    }
    const checkIn = isValidTime(apiData?.CheckIn)
      ? formatTime(apiData.CheckIn)
      : null;
    const checkOut = isValidTime(apiData?.CheckOut)
      ? formatTime(apiData.CheckOut)
      : null;
    let dayCls = "cal-day";
    if (dateStr === todayStr) dayCls += " today";
    else if (status === "WO" || status === "H") dayCls += " weekend";
    else if (dateObj > new Date()) dayCls += " future";
    const statusMeta = getStatusMeta(status);

    const hasValidStatus = apiData?.StatusCode && apiData?.StatusCode !== "-";

    const hasValidTime =
      isValidTime(apiData?.CheckIn) || isValidTime(apiData?.CheckOut);

    const hasLocation =
      !!apiData?.LocationName || !!apiData?.CheckOutLocationName;

    const hasWorkingHours = !!apiData?.TotalWorkingHours;

    const showTooltip =
      hasValidStatus || hasValidTime || hasLocation || hasWorkingHours;
    return (
      <div className={`${dayCls} tooltip-container`} onClick={() => {
        const date = apiData?.AttendanceDate;
        AttendanceHistory(date);
        setSelectedDate(date);
        setShowDrawer(true);
      }}>
        <div className="day-num">{day}</div>
        {statusMeta && status && (
          <div className={`day-badge ${statusMeta.cls}`}>
            {statusMeta.label}
          </div>
        )}
        {isValidTime(apiData?.CheckIn) && (
          <div className="time-hint">
            {checkIn || "--"} - {checkOut || "--"}
          </div>
        )}
        {showTooltip && (
          <div className="tooltip-box">

            {hasValidStatus && (
              <div><b>Status:</b> {status}</div>
            )}

            {hasValidTime && (
              <div>
                {checkIn || "--"} - {checkOut || "--"}
              </div>
            )}

            {apiData?.LocationName && (
              <div><b>In:</b> {apiData.LocationName}</div>
            )}

            {apiData?.CheckOutLocationName && (
              <div><b>Out:</b> {apiData.CheckOutLocationName}</div>
            )}

            {hasWorkingHours && (
              <div><b>Total Hours:</b> {apiData.TotalWorkingHours}</div>
            )}

          </div>
        )}
      </div>
    );
  }

  const [locations, setLocations] = useState([]);

  async function gettGeoTagLocationList() {
    setLoading(true);
    const params = {
      Id: 0,
      PageNumber: 1,
      PageSize: 50,
      GUID: "",
      Search: "",
    };

    try {
      const response = await getGeoTagLocation(params);
      setLoading(false);
      setLocations(response?.Data || []);
    } catch (error) {
      console.error("Error fetching locations:", error);
      setLoading(false);
    }
  }

  const toggleExpand = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div>
      <div className="container-fluid">
        <div className="page-head">
          <div>
            <h2>My Attendance</h2>
            <p>{monthLabel}</p>
          </div>
          <div className="head-actions">
            <Link
              to="/Attendance-Regularization" className="btn-og theme-color btn-og-sm">Request Regularization</Link>
            <Link
              to="/LeaveDashboard"
              className="btn-og btn-og-secondary btn-og-sm"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <i className="fa fa-calendar-plus-o" style={{ width: "18px" }}></i>
              Apply for Leave
            </Link>
            <Link
              to="/Geotag-Locations"
              className="btn-og btn-og-secondary btn-og-sm"
              style={{ display: "flex", justifyContent: "flex-start" }}
            >
              <i className="fa fa-map-marker" style={{ width: "18px" }}></i>
              Geo Tag Locations
            </Link>

          </div>
        </div>

        <div className="stat-grid" style={{ gridTemplateColumns: 'repeat(5,1fr)' }}>
          <div className="stat-card sc-present"><div className="sc-label">Present- <span className="att-badge att-badge-sm att-P">P</span></div><div className="sc-value">{summary.presentMTD}</div><i className="fa fa-check-circle sc-icon"></i></div>
          <div className="stat-card sc-absent"><div className="sc-label">Absent- <span className="att-badge att-badge-sm att-A">A</span></div><div className="sc-value">{summary.absentMTD}</div><i className="fa fa-times-circle sc-icon"></i></div>
          {/* <div className="stat-card sc-late"><div className="sc-label">Late- <span className="att-badge att-badge-sm att-L">L</span></div><div className="sc-value">2</div><div className="sc-sub">Late check-ins</div><i className="fa fa-clock-o sc-icon"></i></div> */}
          <div className="stat-card sc-wfh"><div className="sc-label">WFH Days- <span className="att-badge att-badge-sm att-WFH">WFH</span></div><div className="sc-value">{summary.wfhMTD}</div><i className="fa fa-home sc-icon"></i></div>
          <div className="stat-card sc-leave"><div className="sc-label">Leave Taken- <span className="att-badge att-badge-sm att-LV">LV</span></div><div className="sc-value">{summary.leaveMTD}</div><i className="fa fa-plane sc-icon"></i></div>
          <div className="stat-card sc-total">
            <div className="sc-label">Attendance %</div>
            <div className="sc-value" style={{ color: '#16a34a' }}> {summary.attendanceMTD !== null && summary.attendanceMTD !== undefined
              ? `${summary.attendanceMTD}%`
              : ""}</div>
            <i className="fa fa-trophy sc-icon"></i>
          </div>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: '1.25rem', alignItems: 'start' }}>
          <div>
            <div className="og-card" style={{ marginBottom: 0 }}>
              <div className="og-card-header">
                <div className='og-labels'>

                  <div className="legend-strip">
                    {showLegend && (
                      <>
                        {[
                          { cls: 'att-P', label: 'P', desc: 'Present' },
                          { cls: 'att-A', label: 'A', desc: 'Absent' },
                          // { cls: 'att-L', label: 'L', desc: 'Late' },
                          { cls: 'att-WFH', label: 'WFH', desc: 'Work From Home' },
                          { cls: 'att-LV', label: 'LV', desc: 'Leave' },
                          { cls: 'att-WO', label: 'WO', desc: 'Week Off' },
                          { cls: 'att-H', label: 'H', desc: 'Holiday' },
                          { cls: 'att-HD', label: '½', desc: 'Half Day' },
                        ].map(({ cls, label, desc }) => (
                          <div key={cls} className="legend-item">
                            <span className={`att-badge att-badge-sm ${cls}`}>{label}</span> {desc}
                          </div>
                        ))}</>)}
                    <span className='legends-span'>Legend:</span>
                    <div className='all-labels'>
                      <button onClick={() => setShowLegend(prev => !prev)} className="btn-og btn-og-secondary btn-og-sm"> <i className={`fa ${showLegend ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i></button>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem' }}>
                  <button className="btn-og btn-og-secondary btn-og-sm" onClick={handlePrevMonth}><i className="fa fa-chevron-left"></i></button>
                  <h5 style={{ margin: 0 }}>{monthLabel}</h5>
                  <button className="btn-og btn-og-secondary btn-og-sm" onClick={handleNextMonth}><i className="fa fa-chevron-right"></i></button>
                </div>

                <div style={{ display: 'flex', gap: '.5rem', alignItems: 'center' }}>

                  <button
                    className="btn-og btn-og-secondary btn-og-sm"
                    id="btnCalView"
                    title="calendar"
                    aria-label="calendar"
                    onClick={() => setView('calendar')}
                  >
                    <i className="fa fa-calendar"></i>
                  </button>

                  <button
                    className="btn-og btn-og-secondary btn-og-sm"
                    id="btnListView"
                    title="calendar list"
                    aria-label="calendar list"
                    onClick={() => setView('list')}
                  >
                    <i className="fa fa-list"></i>
                  </button>
                </div>

              </div>



              <div id="calendarView" style={{ padding: '1rem', display: view === 'calendar' ? 'block' : 'none' }}>
                <FullCalendar
                  plugins={[dayGridPlugin, interactionPlugin]}
                  key={monthLabel}
                  initialDate={currentMonth}
                  headerToolbar={{
                    left: "",
                    center: "title",
                    right: ""
                  }}
                  datesSet={handleDatesChange}
                  dayCellContent={(arg) => renderDayCell(arg.date)}
                  height={730}
                  fixedWeekCount={false}
                  showNonCurrentDates={true}
                />
              </div>

              <div id="listCalView" style={{ display: view === 'list' ? 'block' : 'none' }}>
                <div className="table-scroll">
                  <table className="og-table" style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th>Date</th><th>Day</th><th>Status</th>
                        <th>Check In</th><th>Check Out</th>
                        <th>Hours</th><th>Check-In Location</th>
                        {/* <th>Check-Out Location</th><th>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {attendanceList && attendanceList.length > 0 ? (
                        attendanceList.map((item, index) => {
                          const date = item.AttendanceDate ? new Date(item.AttendanceDate) : null;
                          const day = date ? date.getDate() : "-";
                          const dow = date ? DOW_NAMES[date.getDay()] : "-";
                          const status = getStatusMeta(item.StatusCode);
                          return (
                            <tr key={index}>
                              <td className='set-bold'>
                                {item.day ? `${item.day} ${monthLabel}` : "-"}
                              </td>
                              <td>{dow}</td>

                              <td>
                                <span className={`att-badge att-badge-sm ${status.cls}`}>
                                  {status.label}
                                </span>
                              </td>
                              <td className='green-color'>
                                {isValidTime(item.CheckIn) ? formatDate(item.CheckIn, "time") : "--"}
                              </td>

                              <td className="light-color">
                                {isValidTime(item.CheckOut) ? formatDate(item.CheckOut, "time") : "--"}
                              </td>

                              <td className='set-bold'> {item.TotalWorkingHours || '0'}h</td>
                              <td>{item.LocationName || "-"}</td>
                              <td>{item.CheckOutLocationName || "-"}</td>

                              {/* <td>
                                <button
                                  className="btn-og btn-og-outline btn-og-xs"
                                  onClick={() => ogOpenModal('regulariseModal')}
                                >
                                  <i className="fa fa-edit"></i>
                                </button>
                              </td> */}
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center' }}>
                            N/A
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', top: '18px', position: 'sticky' }}>
            <div className="day-detail">
              <div className="day-detail-header">
                <div className="date-bubble">
                  <div className="d-day">{dateData?.day || '--'}</div>
                  <div className="d-mon">{dateData?.month || '--'}</div>
                </div>
                <div>
                  <div className="day-info">TODAY <b> {dateData?.weekday || '--'}</b></div>
                  {/* <div style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>{todayAttendance?.LocationName || '--'} &nbsp;·&nbsp; Within geo-fence</div>
                  <span className={`att-badge att-badge-md ${statusData.cls}`}>
                    {statusData.label} — {statusData.desc}
                  </span> */}
                </div>
              </div>

              <div style={{ margin: '0 21px 20px' }}>
                <div className='mark-live-status active-status'>
                  <div className='mark-status-count'>
                    <div className='mark-left'>
                      <div className='mark-live-title'>
                        {currentCheck?.LogType || 'Not Checked In'}
                      </div>

                      <div className='mark-live-time'>
                        {currentCheck?.LogTime
                          ? formatTime(currentCheck?.LogTime)
                          : '--'}
                      </div>
                      <div className='mark-live-location'>
                        <i className="fa fa-map-marker"></i>&nbsp;&nbsp;{currentCheck?.IswithinGeofence === 1 ? 'Geo verified' : '--'}
                      </div>
                    </div>
                    <div className='mark-right'>
                      <div className="hours-ring">

                        <svg width="80" height="80" viewBox="0 0 90 90">
                          <circle cx="45" cy="45" r="36" fill="none" stroke="#fdd5cd" stroke-width="8"></circle>
                          <circle
                            cx="45"
                            cy="45"
                            r="36"
                            fill="none"
                            stroke="#e84b2d"
                            strokeWidth="8"
                            strokeDasharray={circumference}
                            strokeDashoffset={strokeDashoffset}
                            strokeLinecap="round"
                          />
                        </svg>
                        <div className="ring-text">
                          <div className="ring-val">{currentCheck?.TotalWorkingHours}h</div>
                          {/* <div className="ring-lbl">of 9h</div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    className={currentCheck?.IsCheckedIn === 0 ? 'check-inbtn' : 'check-outbtn'}
                    onClick={() => setShowCheckStatus(true)}
                  >
                    {!currentCheck || currentCheck?.IsCheckedIn === 0 ? 'Check In' : 'Check Out'}
                  </button>

                </div>
              </div>
              <div className="timeline-item">
                <div className="timeline-dot tl-success"><i className="fa fa-location-pin"></i></div>
                <div>
                  <div style={{ fontWeight: '600', fontSize: '.8rem' }}>Last Location</div>
                  <div style={{ fontSize: '.72rem', color: 'var(--text-muted)' }}>{currentCheck?.LocationName}</div>
                </div>
              </div>
              {/* <div style={{ margin: '0 21px 20px' }}>
                <div className='progress-section'>
                  <div className="prog-title">Daily progress</div>
                  <div className="hours-ring">

                    <svg width="90" height="90" viewBox="0 0 90 90">
                      <circle
                        cx="45"
                        cy="45"
                        r="36"
                        fill="none"
                        stroke="#16a34a"
                        strokeWidth="8"
                        strokeDasharray={circumference}
                        strokeDashoffset={strokeDashoffset}
                        strokeLinecap="round"
                      />
                    </svg> */}
              {/* <div className="ring-text">
                      <div className="ring-val">{currentCheck?.TotalWorkingHours}h</div> */}
              {/* <div className="ring-lbl">of 9h</div> */}
              {/* </div>
                  </div> */}
              {/* <div className="prog-note">
                    Worked {currentCheck?.TotalWorkingHours}h so far today
                  </div> */}
              {/* </div>
              </div> */}


            </div>

            {/* Monthly Progress and Quick Actions cards remain exactly as you had */}
            <div className="og-card">
              <div className="og-card-header">
                <h5>Monthly Progress</h5>
                <span style={{ fontSize: '.75rem', color: 'var(--text-muted)' }}>
                  {monthLabel}
                </span>
              </div>

              <div className="og-card-body">
                {/* Attendance Rate (from API) */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '.75rem', marginBottom: '.85rem' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      fontSize: '.72rem',
                      color: 'var(--text-muted)',
                      marginBottom: '.3rem',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}>
                      <span>Attendance Rate</span>
                      <strong style={{ color: '#16a34a' }}>
                        {summary.attendanceMTD || 0}%
                      </strong>
                    </div>

                    <div style={{ background: '#f4f6f9', borderRadius: '20px', height: '8px' }}>
                      <div
                        style={{
                          background: '#16a34a',
                          height: '8px',
                          borderRadius: '20px',
                          width: `${summary.attendanceMTD || 0}%`
                        }}
                      ></div>
                    </div>
                  </div>
                </div>

                {/* Summary Bar (based on API counts) */}
                <div className="month-summary-bar" style={{ marginBottom: '.5rem' }}>
                  <div className="msb-seg" style={{
                    background: '#16a34a',
                    width: `${summary.presentMTD || 0}%`
                  }}></div>

                  <div className="msb-seg" style={{
                    background: '#6366f1',
                    width: `${summary.wfhMTD || 0}%`
                  }}></div>

                  <div className="msb-seg" style={{
                    background: '#f59e0b',
                    width: `${summary.leaveMTD || 0}%`
                  }}></div>

                  <div className="msb-seg" style={{
                    background: '#ef4444',
                    width: `${summary.absentMTD || 0}%`
                  }}></div>
                </div>

                {/* Chips (direct binding) */}
                <div style={{ display: 'flex', gap: '.5rem', flexWrap: 'wrap' }}>
                  <span className="leave-chip" style={{ background: '#dcfce7', color: '#16a34a' }}>
                    ● Present {summary.presentMTD || 0}
                  </span>

                  <span className="leave-chip" style={{ background: '#ede9fe', color: '#6d28d9' }}>
                    ● WFH {summary.wfhMTD || 0}
                  </span>

                  <span className="leave-chip" style={{ background: '#fef3c7', color: '#d97706' }}>
                    ● Leave {summary.leaveMTD || 0}
                  </span>

                  <span className="leave-chip" style={{ background: '#fee2e2', color: '#dc2626' }}>
                    ● Absent {summary.absentMTD || 0}
                  </span>
                </div>
              </div>
            </div>



            {showDrawer && (
              <>
                <div
                  className="drawer-overlay"
                  onClick={() => setShowDrawer(false)}
                />
                <div className={`side-drawer ${showDrawer ? 'open' : ''}`}>
                  <h4>Ckeck-In Logs<span>({selectedDate ? new Date(selectedDate).toLocaleDateString("en-IN") : "--"})</span>
                    <svg onClick={() => setShowDrawer(false)} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg></h4>
                  {checkHistory && checkHistory.length > 0 ? (
                    checkHistory.map((log, index) => {
                      const isCheckIn = log.IsCheckIn === 1;
                      const label = log.LogType || (isCheckIn ? 'Check In' : 'Check Out');
                      const time = formatTime(log.LogTime);

                      const geofence = log.IsWithinGeofence
                        ? 'Inside Geofence'
                        : 'Outside Geofence';

                      return (

                        <div
                          key={log.Id || index}
                          className="log-card"
                          style={{ animationDelay: `${index * 0.07}s` }}
                        >
                          <div className="log-card-header">
                            <div className={`log-icon ${isCheckIn ? 'icon-checkin' : 'icon-checkout'}`}>
                              {isCheckIn ? '↙' : '↗'}
                            </div>
                            <span className="log-type">{label}</span>
                            <span className="log-time">{time}</span>
                          </div>

                          <div className="log-details">
                            <div className="detail-row">
                              <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-geo-alt-fill" viewBox="0 0 16 16">
                                <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6" />
                              </svg></span>
                              <span className="label">Location:</span>
                              <span className="value">
                                {log.LocationName || log.CheckOutLocationName || 'N/A'}
                              </span>
                            </div>

                            <div className="detail-row">
                              <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-radar" viewBox="0 0 16 16">
                                <path d="M6.634 1.135A7 7 0 0 1 15 8a.5.5 0 0 1-1 0 6 6 0 1 0-6.5 5.98v-1.005A5 5 0 1 1 13 8a.5.5 0 0 1-1 0 4 4 0 1 0-4.5 3.969v-1.011A2.999 2.999 0 1 1 11 8a.5.5 0 0 1-1 0 2 2 0 1 0-2.5 1.936v-1.07a1 1 0 1 1 1 0V15.5a.5.5 0 0 1-1 0v-.518a7 7 0 0 1-.866-13.847" />
                              </svg></span>
                              <span className="label">Geo Fence:</span>
                              <span className={`value ${log.IsWithinGeofence ? 'green' : ''}`}>
                                {geofence}
                              </span>
                            </div>

                            <div className="detail-row">
                              <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-phone-fill" viewBox="0 0 16 16">
                                <path d="M3 2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm6 11a1 1 0 1 0-2 0 1 1 0 0 0 2 0" />
                              </svg></span>
                              <span className="label">Device OS:</span>
                              <span className="value">
                                {log.OSVersion ? (
                                  <>
                                    {expandedRows[index]
                                      ? log.OSVersion
                                      : log.OSVersion.length > 38
                                        ? log.OSVersion.slice(0, 38) + "…"
                                        : log.OSVersion}

                                    {log.OSVersion.length > 38 && (
                                      <span
                                        onClick={() => toggleExpand(index)}
                                        style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                                      >
                                        {expandedRows[index] ? "Show less" : "Read more"}
                                      </span>
                                    )}
                                  </>
                                ) : (
                                  "--"
                                )}
                              </span>
                            </div>

                            {/* <div className="detail-row">
                              <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-radar" viewBox="0 0 16 16">
                                <path d="M6.634 1.135A7 7 0 0 1 15 8a.5.5 0 0 1-1 0 6 6 0 1 0-6.5 5.98v-1.005A5 5 0 1 1 13 8a.5.5 0 0 1-1 0 4 4 0 1 0-4.5 3.969v-1.011A2.999 2.999 0 1 1 11 8a.5.5 0 0 1-1 0 2 2 0 1 0-2.5 1.936v-1.07a1 1 0 1 1 1 0V15.5a.5.5 0 0 1-1 0v-.518a7 7 0 0 1-.866-13.847" />
                              </svg></span>
                              <span className="label">Mock GPS:</span>
                              <span className={`badge-mock ${!log.IsMockGpsDetected ? 'badge-safe' : ''}`}>
                                {log.IsMockGpsDetected ? '⚠ Mock GPS' : '✔ GPS Real'}
                              </span>
                            </div> */}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{ textAlign: 'center', fontSize: '.8rem' }}>
                      No History Found
                    </div>
                  )}
                </div>
              </>
            )}


          </div>
        </div>
        {showCheckStatus && (
          <div
            onClick={() => setShowCheckStatus(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: +9,
              cursor: "pointer"
            }}
          >
            <div
              className="og-modal og-modal-sm og-attendance-modal"
              onClick={(e) => e.stopPropagation()}
              style={{ background: "white", borderRadius: "12px" }}
            >
              <div className="og-modal-header">
                <div className="og-modal-title">
                  <div className='modal-title-icon'>
                    <svg viewBox="0 0 24 24" fill="none" stroke="#671cc9" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
                    </svg></div>
                  <h5>{!currentCheck || currentCheck?.IsCheckedIn === 0 ? 'Check In' : 'Check Out'}?</h5>
                </div>
                <button
                  type="button"
                  className="modal-close og-modal-close"
                  onClick={() => setShowCheckStatus(false)}
                >
                  <i className="fa fa-times"></i>
                </button>
              </div>

              <div className="og-modal-body">
                <div className="check-circle">
                  <svg viewBox="0 0 24 24" fill="none" stroke="#ec4119" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                    <circle cx="12" cy="7" r="4"></circle>
                  </svg>
                </div>
                <p>
                  Are you sure you want to {!currentCheck || currentCheck?.IsCheckedIn === 0 ? 'check in' : 'check out'}&nbsp;now?
                </p>
                {/* <div className="time-chip">
                  <div className="time-dot"></div>
                  <span className="time-text">Today, {dateData?.weekday} — {currentCheck?.LogTime
                    ? formatTime(currentCheck?.LogTime)
                    : '--'}</span>
                </div> */}
              </div>

              <div className="og-modal-footer">
                <button
                  type="button"
                  className="btn-og btn-og-secondary cancel"
                  onClick={() => setShowCheckStatus(false)}
                >
                  Cancel
                </button>
                {currentCheck?.IsCheckedIn === 0 && (
                  <button
                    type="button"
                    className="btn-og btn-og-danger save"
                    onClick={() => { addCheckInStatus(1) }}>
                    Check In
                  </button>
                )}

                {currentCheck?.IsCheckedIn === 1 && (
                  <button
                    type="button"
                    className="btn-og btn-og-danger save"
                    onClick={() => { addCheckInStatus(0) }}>
                    Check Out
                  </button>)}
                {currentCheck == null && (
                  <button
                    type="button"
                    className="btn-og btn-og-danger save"
                    onClick={() => { addCheckInStatus(1) }}>
                    {/* {!currentCheck || currentCheck?.IsCheckedIn === 0 ? '' : 'Check Out'} */}
                    Check In
                  </button>)}

              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal - kept your original structure */}
      <div className="og-modal-overlay" id="regulariseModal">
        <form >
          <div className="og-modal">
            <div className="og-modal-header">
              <i className="fa fa-edit" style={{ color: 'var(--primary)', fontSize: '1.1rem' }}></i>
              <h5>Request Attendance Regularization</h5>
              <button className="modal-close" onClick={() => ogCloseModal('regulariseModal')}><i className="fa fa-times"></i></button>
            </div>
            <div className="og-modal-body">
              <div style={{ background: '#fff8f0', border: '1px solid #fcd9c5', borderRadius: '8px', padding: '.65rem .85rem', marginBottom: '1rem', fontSize: '.77rem', color: '#c94a00' }}>
                <i className="fa fa-info-circle" style={{ marginRight: '.35rem' }}></i>
                Regularization requests are reviewed by your manager. You can submit up to <strong>3 requests per month</strong>.
              </div>
              <div className="form-group">
                <label className="og-label">Date <span className="req">*</span></label>
                <input type="date" className="og-input" defaultValue="2026-04-05" />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                <div className="form-group">
                  <label className="og-label">Actual Check-In <span className="req">*</span></label>
                  <input type="time" className="og-input" defaultValue="09:30" />
                </div>
                <div className="form-group">
                  <label className="og-label">Actual Check-Out <span className="req">*</span></label>
                  <input type="time" className="og-input" defaultValue="19:15" />
                </div>
              </div>
              <div className="form-group">
                <label className="og-label">Reason <span className="req">*</span></label>
                <select className="og-select">
                  <option>— Select Reason —</option>
                  <option>Network/system issue prevented check-in</option>
                  <option>Forgot to mark attendance</option>
                  <option>GPS was unavailable at the time</option>
                  <option>Working at client site (outside geo-fence)</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="form-group">
                <label className="og-label">Additional Details</label>
                <textarea className="og-textarea" rows="3" placeholder="Provide additional context for your request…"></textarea>
              </div>
            </div>
            <div className="og-modal-footer">
              <button className="btn-og btn-og-secondary" onClick={() => ogCloseModal('regulariseModal')}>Cancel</button>
              <button className="btn-og btn-og-primary" onClick={() => { ogCloseModal('regulariseModal'); ogToast('Regularization request submitted to your manager.'); }}>
                <i className="fa fa-paper-plane"></i> Submit Request
              </button>
            </div>
          </div>
        </form>
      </div>



      {
        loading ? (
          <Suspense >
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )
      }
    </div >
  );
};

export default My_Attendance;